import {r as register} from '@theme/theme-sections';
import {F as Flickity} from '@theme/flickity';
import '@theme/flickity-fade';
import '@theme/_commonjsHelpers';

const selectors = {
  sliderContainer: '[data-announcement-container]',
  slide: '[data-announcement]',
};
const sectionType = 'announcement-bar';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};

if (!registeredSections[sectionType]) {
  register(sectionType, {
    onLoad() {
      if (sessionStorage.getItem('announcementBar')) return;
      document.body.classList.add('has-announcement-bar');
      const slider = this.container.querySelector(selectors.sliderContainer);
      if (!slider) return;

      this.container.classList.remove('hide');
      if (slider.classList.contains('single-slide')) {
        this.container.querySelector(selectors.slide)?.classList.add('is-selected');
        return;
      }

      this.flickity = new Flickity(slider, {
        prevNextButtons: false,
        autoPlay: 4500,
        pageDots: false,
        // Reserve the tallest slide so wrapped mobile announcements do not move the header.
        adaptiveHeight: false,
        fade: true,
      });

      if ('ResizeObserver' in window) {
        const slideSizes = new WeakMap();
        this.scheduleAnnouncementResize = () => {
          if (!this.announcementResizePending || this.announcementResizeFrame || !this.flickity) return;
          this.announcementResizeFrame = window.requestAnimationFrame(() => {
            this.announcementResizeFrame = null;
            // Flickity ignores resize during a fade or drag. Keep the request for settle.
            if (!this.flickity || this.flickity.isAnimating || this.flickity.isDragging) return;
            this.announcementResizePending = false;
            this.flickity.resize();
          });
        };
        this.announcementResizeObserver = new window.ResizeObserver((entries) => {
          let changed = false;
          for (const {target, contentRect} of entries) {
            const previous = slideSizes.get(target);
            if (previous?.width === contentRect.width && previous?.height === contentRect.height) continue;
            slideSizes.set(target, {width: contentRect.width, height: contentRect.height});
            changed = true;
          }
          if (!changed) return;
          this.announcementResizePending = true;
          this.scheduleAnnouncementResize();
        });
        // Observe natural cell sizes, not Flickity's explicitly sized viewport, to avoid a height loop.
        this.container.querySelectorAll(selectors.slide).forEach((slide) => this.announcementResizeObserver.observe(slide));
        this.flickity.on('settle', this.scheduleAnnouncementResize);
      }
    },
    onBlockSelect(event) {
      if (!window.Shopify?.designMode || !this.flickity) return;
      const slide = event.target.closest?.(selectors.slide);
      const index = Array.from(this.container.querySelectorAll(selectors.slide)).indexOf(slide);
      if (index < 0) return;
      this.flickity.pausePlayer();
      this.flickity.select(index);
    },
    onBlockDeselect() {
      if (window.Shopify?.designMode) this.flickity?.unpausePlayer();
    },
    onDeselect() {
      if (window.Shopify?.designMode) this.flickity?.unpausePlayer();
    },
    onUnload() {
      this.announcementResizeObserver?.disconnect();
      this.announcementResizeObserver = null;
      if (this.announcementResizeFrame) window.cancelAnimationFrame(this.announcementResizeFrame);
      this.announcementResizeFrame = null;
      this.announcementResizePending = false;
      if (this.scheduleAnnouncementResize) this.flickity?.off('settle', this.scheduleAnnouncementResize);
      this.scheduleAnnouncementResize = null;
      this.flickity?.destroy();
      this.flickity = null;
    },
  });
}
